"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _index = require("../../../material/index");

var _index2 = require("../../../utils/index");

var _index3 = require("../../../utils/styles/index");

var _reactJss = _interopRequireDefault(require("react-jss"));

var _ellipsis_styles = _interopRequireDefault(require("./ellipsis_styles"));

var _ellipsis_definition = _interopRequireDefault(require("./ellipsis_definition"));

var _definecomponent = require("../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
// material
// utils
// styles
// definition

/* ========== ~~~~~~~~~~ EXPORT : ELLIPSIS ~~~~~~~~~~ ========== */


var Ellipsis = (0, _reactJss.default)(_ellipsis_styles.default)(function (props) {
  return _react.default.createElement(_index.ToolTip, {
    position: props.tooltip,
    action: "mouseenter",
    content: props.children
  }, _react.default.createElement("span", {
    className: "ellipsis ".concat((0, _index2.generateClasses)(props), " ").concat(props.classes.ellipsis),
    style: {
      width: "".concat((0, _index3.pxToEm)(props.width))
    }
  }, props.children));
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(Ellipsis, _ellipsis_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = Ellipsis;
exports.default = _default;